import { useState } from 'react';

import { useTimer } from '@/shared/hooks/export';
import { CountryFlag } from '@/shared/components/export';
import { DateFormat } from '@/core/date/export';
import { readerService } from '@/modules/calendar/services';
import { DataSeriesReading } from '@/modules/calendar/services/data-series-reading';

export default function ReaderIndicator() {
  const [dataSeriesReading, setDataSeriesReading] = useState<DataSeriesReading | undefined>(
    undefined,
  );

  useTimer(
    1000,
    () => {
      setDataSeriesReading(readerService.getDataSeriesReading());
    },
    false,
  );

  return (
    <>
      {dataSeriesReading && (
        <small className={' text-body'}>
          Reading <CountryFlag country={dataSeriesReading.country} height={12} />
          <span className={'font-monospace fw-bold'}> {dataSeriesReading.text} </span>
          @<DateFormat format={'M/D h:mm a'} date={dataSeriesReading?.date} />{' '}
        </small>
      )}
    </>
  );
}
